import { openBlock as t, createElementBlock as o, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(v, e) {
  return t(), o("svg", n, [...e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      d: "M12.778 21a.72.72 0 0 1-.554-.247.87.87 0 0 1-.224-.61q0-.364.224-.61a.72.72 0 0 1 .554-.247h4.666v-.857H15.89q-.642 0-1.098-.504a1.74 1.74 0 0 1-.458-1.21v-3.43q0-.705.458-1.21.456-.504 1.098-.504h1.555v-.857q0-2.485-1.594-4.243Q14.256 4.714 12 4.714T8.15 6.471t-1.594 4.243v.857H8.11q.642 0 1.098.504.458.505.458 1.21v3.43q0 .705-.458 1.21-.456.504-1.098.504H6.556q-.642 0-1.1-.504A1.74 1.74 0 0 1 5 16.715v-6q0-1.587.554-2.99A8 8 0 0 1 7.06 5.27a7.2 7.2 0 0 1 2.226-1.66A6.2 6.2 0 0 1 12 3a6.2 6.2 0 0 1 2.713.61q1.273.612 2.226 1.661a8 8 0 0 1 1.507 2.454q.555 1.403.554 2.99v8.57q0 .708-.457 1.212-.456.503-1.099.503zm-6.222-4.286H8.11v-3.428H6.556zm9.333 0h1.555v-3.428H15.89z"
    }, null, -1)
  ])]);
}
const a = { render: l };
export {
  a as default,
  l as render
};
